export class Xml {
  xml: string;
  companyId: string;
  cpfCNPJMember: string;
  keyId: string;
  modelType: string;
  issuer: string;
  addressee: string;
}
